import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
import { CardBody, Col, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Label, ModalFooter, Row } from "reactstrap";
import { IMAGE_EXTENTION } from "../../../../Data/extentionImage";
import { FileStatus } from "../../../../models/fileStatus";
import StepperActionButtons from "../../../stepper-action-button/stepperActionButton";
import { toast } from "react-toastify";
import styles from "./stepTwo.module.scss";
import { translate } from "react-switch-lang";

const StepTwo = (props: any) => {
  toast.configure();
  const [errorsLink, setErrorsLink] = useState("");
  const [isShowDropZone, setIsShowDropZone] = useState(true);
  const [selectedSupport, setSelectedSupport] = useState<any>(null);
  const [urlImage, setUrlImage] = useState("");
  const [link, setLink] = useState("");

  const validateYouTubeUrl = () => {
    if (link !== undefined || link !== "") {
      // eslint-disable-next-line no-useless-escape
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = link.match(regExp);
      if (match && match[2].length === 11) {
        setErrorsLink("");

        // Do anything for being valid
        // if need to change the url to embed url then use below line
      } else {
        // setErrorsLink("le lien est invalide");
      }
    }
  };

  useEffect(() => {
    if (props.support) {
      setLink(props.support.link);
      if (props.support.urlSupport) {
        setIsShowDropZone(false);
        props.setIsShowZone(false);
      }
      //   setChecked(props.support.download);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === FileStatus.REMOVED) {
      setSelectedSupport(null);
      props.setSelectedSupport(null);
      props.setIsShowZone(false);
    } else {
      if (IMAGE_EXTENTION.includes(file.name.slice(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase())) {
        if (status === FileStatus.DONE) {
          setSelectedSupport(file);
          props.setSelectedSupport(file);
          setUrlImage(meta.previewUrl);
        }
      } else {
        toast.error(String(props.t("message_extention_not_allowed")));
      }
    }
  };
  return (
    <div className="card m-b-0 p-t-40">
      <CardBody className="p-t-5 p-b-5">
        <Col md="12">
          <Col md="12">
            <FormGroup className="m-t-10 m-b-30">
              <Label id="document">{props.t("video_modale.label_youtube_link")}*</Label>
              <InputGroup className="m-b-20">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="icofont icofont-download"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <input
                  value={link}
                  onChange={event => {
                    setLink(event.target.value);
                    props.setLink(event.target.value);
                    validateYouTubeUrl();
                  }}
                  className="form-control input-group-air"
                  type="text"
                  placeholder={props.t("video_modale.input_placeholder_youtube")}
                />
              </InputGroup>
              <span style={{ color: "red" }}>{errorsLink}</span>
            </FormGroup>
            <FormGroup style={{ width: "100%" }}>
              <Row>
                <Col xl="12" sm="12" md={{ size: 12, offset: 0 }}>
                  <Label id="upload">{props.t("video_modale.label_representative_image")}</Label>
                  {isShowDropZone &&
                    (!selectedSupport ? (
                      <Dropzone
                        key="in"
                        onChangeStatus={handleChangeStatus}
                        maxFiles={1}
                        accept={"image/*"}
                        multiple={false}
                        canCancel={true}
                        inputContent={
                          <div key="4">
                            <span style={{ fontSize: "25px", color: "black" }} className="bold">
                              <i className="fa fa-plus"></i> {props.t("video_modale.label_choose_image")}
                            </span>
                            <div style={{ fontSize: "14px", color: "gray" }}>{props.t("pdf_modale.label_drag_and_drop_here")}</div>
                          </div>
                        }
                        styles={{
                          dropzone: { width: "100%", height: 100, background: "#efefefbf", border: "none !important" },
                          dropzoneActive: { border: "none !important" },
                        }}
                      />
                    ) : (
                      <div className="text-center" style={{ width: "100%" }}>
                        <div className="uploadPictureP">
                          <div
                            onClick={() => {
                              setSelectedSupport(null);
                              props.setSelectedSupport(null);
                            }}
                            className={styles["deleteImageVideo"]}
                          >
                            X
                          </div>
                          {selectedSupport.previewUrl}
                          <img className={styles["defaultImage"]} src={urlImage} alt="" />
                        </div>
                      </div>
                    ))}
                </Col>

                {!isShowDropZone && (
                  <div className="text-center" style={{ width: "100%" }}>
                    <div className="uploadPictureP">
                      <div
                        onClick={() => {
                          setIsShowDropZone(!isShowDropZone);
                          props.setIsShowZone(true);
                          setSelectedSupport(null);
                          props.setSelectedSupport(null);
                        }}
                        className={styles["deleteImageVideo"]}
                      >
                        X
                      </div>
                      <img className={styles["defaultImage"]} src={props.support?.urlSupport + "/preview"} alt="" />
                    </div>
                  </div>
                )}
              </Row>
            </FormGroup>
          </Col>
          <ModalFooter className="m-t-30 p-b-0 p-t-5">
            <StepperActionButtons disable={link === "" || link === null} lastStep={() => {}} {...props} nextStep={() => {}} />
          </ModalFooter>
        </Col>
      </CardBody>
    </div>
  );
};

export default translate(StepTwo);
